export default __webpack_public_path__ + "static/footer-logo-tm-3084866acc89d0e576664948c1383fdc.png";